<template>
<div class="col-12 md:col-4">

<div class="grid">
<div class="col-7  mt-3">


<MultiSelect
v-model="$store.state.audit.selected_options" 
display="chip" :options="options" 
optionLabel="name" 
optionValue="id" 
placeholder="İşaretlemeye göre filtrele"
class="w-full  p-inputtext-sm" 
@change="optionsChanged" 
v-if="$store.state.audit.display=='questions'"/>

</div>
<!--
<div class="col-4 mt-3">
<InputText type="text" v-model="searchterm" v-if="$store.state.audit.display=='questions'" class="w-full p-inputtext-sm mb-0 mr-3" @input="searchTermChanged" placeholder="Arama" @keydown.esc="clearSearch"/>
</div>
-->
<div class="col-5 mt-3">
<Button label="Liste Olarak Göster" v-if="$store.state.audit.display=='sections'" class="w-full p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" @click="swithcDisplay('questions')"></Button>

<Button label="Bölümleri Göster" v-if="$store.state.audit.display=='questions'" class="w-full p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" @click="swithcDisplay('sections')"></Button>
</div>

</div>

</div>


</template>

<script>
export default {

  name: 'AuditViewSwitch',

  data () {
    return {
    	searchterm:"",
      show_empty:false,
      options:[],
      //selected_options:[],
    }
  },
  mounted()
  {
    this.options = this.sanitizeArray(this.$store.state.audit.questionlist.options)

    this.options.push({id:"empty",name:"Boş Bırakılanlar"})
    this.$store.dispatch('audit/setSelectedOptions',[]) 
  },
  methods:{
    optionsChanged(data)
    {
      console.log(data)
      if(data.value)
      {
        this.mapInputfields(data.value)
      }
      

    },
    toggleShowEmpty()
    {
      
      if(this.show_empty)
      {
        this.mapInputfields()
      }
      else
      {
        this.mapInputfields()
      }
    },
  	swithcDisplay(type)
  	{
      //console.log(this.$store.state.audit.questionlist)
  		this.$store.dispatch('audit/setDisplay',type)
  		if(type=="questions")
      {
        this.$store.dispatch('audit/setSelectedOptions',[]) 
        this.$router.push({ name: 'AuditQuestionList' })
        this.mapInputfields()
      }
      if(type=="sections")
      {
        this.getAndParseAuditData()
      }
  		
  		
  	},
  	clearSearch()
  	{

  	},
  	searchTermChanged()
  	{

  	},
  }
}
</script>

<style lang="css" scoped>
</style>